import Agenda from "./components/agenda";

import {HashRouter, Route, Switch } from 'react-router-dom';
import WebNavbar from "./components/navbar/navbar";

function App() {
  return (
   
    <HashRouter basename='/'>
    <div>
      
        <Switch>
         <Route path="/" component={WebNavbar} exact/>
         <Route path="/agenda" component={Agenda}/>
        <Route component={Error}/>
       </Switch>
    </div> 
  </HashRouter>
  );
}

export default App;
